<app-loading *ngIf="isLoading$ | async" title="step groups"></app-loading>
<ng-container *ngIf="!(isLoading$ | async) && !this.checkoutUrl">
    <div class="plan-detail-outer">
        <div class="left-storage-nav">
            <h2 i18n="@@cloudStorage">Plan Selection</h2>
            <ul class="card-ul">
                <ng-container *ngIf="newPlanList?.length">
                    <li
                            class="card-li"
                            *ngFor="let plan of plansBasedOnCycle; let i = index"
                            [class.activee]="activeIndex === i + 1"
                            (click)="!exceedCamCap(plan) && setActive(i + 1, plan)"
                    >
                        <div class="li-heading-wrapper">
                            <p class="li-heading">
                                {{ plan?.name }}
                                <span style="visibility: hidden"> {{ plan?.id }}</span>
                            </p>
                            <p *ngIf="exceedCamCap(plan)">
                <span class="badge text-bg-warning"
                >Unavailable for multiple cameras</span
                >
                            </p>
                            <button
                                    *ngIf="plan?.type == 'promotional'"
                                    class="li-heading-btn"
                                    i18n="@@recommended"
                            >
                                Recommended
                            </button>
                        </div>
                        <ul class="listing-ul">
                            <li i18n="@@thirtyDaysBackupSingle">{{ plan?.desc }}</li>
                        </ul>
                        <!-- <p>${{plan?.availability?.prices?.US?.price}} {{ plan?.availability?.prices?.US?.cycle === 'monthly' ? 'per month' : 'per year' }}</p> -->
                        <ng-container>
                            <p *ngIf="getPriceForRegion(plan, 'monthly', region)">
                                ${{ getPriceForRegion(plan, "monthly", region) }}
                                per month
                            </p>
                            <p *ngIf="getPriceForRegion(plan, 'yearly', region)">
                                <span style="font-weight: bolder"> ${{ Math.round(getPriceForRegion(plan, "yearly", region) * 100 ) / 100 }} </span>
                                per year
                                <!--
                                <span style="font-weight: bolder"> ${{ Math.round(getPriceForRegion(plan, "yearly", region) * 100 / 2) / 100 }} </span>
                                per year

                                <span style="text-decoration: line-through; color: darkred">Reg.: ${{ getPriceForRegion(plan, "yearly", region) }}</span>
                                <span class="alert alert-info" style="clear:both; display: block; margin-top: 20px"> Cyber Monday Deal: Get 50% off the first year of the annual plan. </span>
                                -->
                            </p>

                        </ng-container>
                    </li>
                    <ng-container *ngIf="!plansBasedOnCycle.length">
                        <div class="plan-wrapper">
                            <p class="no-device-text" i18n="@@noExist">No Plans Exist</p>
                        </div>
                    </ng-container>

                    <li>
                        <div class="pricing-card-wrapper">
                            <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <button
                                            class="nav-link active"
                                            id="pills-home-tab"
                                            data-bs-toggle="pill"
                                            data-bs-target="#pills-home"
                                            type="button"
                                            role="tab"
                                            aria-controls="pills-home"
                                            aria-selected="true"
                                            (click)="setActiveTab('monthly')"
                                            i18n="@@monthly"
                                    >
                                        Monthly
                                    </button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button
                                            class="nav-link"
                                            id="pills-profile-tab"
                                            data-bs-toggle="pill"
                                            data-bs-target="#pills-profile"
                                            type="button"
                                            role="tab"
                                            aria-controls="pills-profile"
                                            aria-selected="false"
                                            (click)="setActiveTab('yearly')"
                                            i18n="yearly"
                                    >
                                        Yearly
                                    </button>
                                </li>
                            </ul>
                            <div class="tab-content" id="pills-tabContent">
                                <div
                                        class="tab-pane fade show active"
                                        id="pills-home"
                                        role="tabpanel"
                                        aria-labelledby="pills-home-tab"
                                        tabindex="0"
                                ></div>
                                <div
                                        class="tab-pane fade"
                                        id="pills-profile"
                                        role="tabpanel"
                                        aria-labelledby="pills-profile-tab"
                                        tabindex="0"
                                ></div>
                            </div>
                        </div>
                        <div class="price-detail">
                            <p *ngIf="currentPrice">
                                <sup *ngIf="showPriceTag">$</sup>{{ currentPrice }}
                            </p>
                        </div>
                        <div class="price-detail-button">
                            <button
                                    class="btn"
                                    [disabled]="!activePlan || !currentPrice"
                                    i18n="@@planContinue"
                                    (click)="onClickCheckout()"
                            >
                                Select plan and continue
                                <span>
                  <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="19.212"
                          height="16.842"
                          viewBox="0 0 19.212 16.842"
                  >
                    <g
                            id="Group_11881"
                            data-name="Group 11881"
                            transform="translate(-443.343 -907.672)"
                    >
                      <line
                              id="Line_743"
                              data-name="Line 743"
                              x1="17.012"
                              transform="translate(444.443 916.093)"
                              fill="none"
                              stroke="#fff"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2.2"
                      />
                      <path
                              id="Path_11696"
                              data-name="Path 11696"
                              d="M13.731,0,6.866,6.866,0,0"
                              transform="translate(454.589 922.958) rotate(-90)"
                              fill="none"
                              stroke="#fff"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2.2"
                      />
                    </g>
                  </svg>
                </span>
                            </button>
                        </div>
                    </li>
                </ng-container>
            </ul>
        </div>

        <div class="plan-detail-wrapper">
            <div class="protect-against-wrapper">
                <h3 class="plan-detail-heading" i18n="@@planDetails">Plan Details</h3>
                <p class="protect-desc" i18n="@@protectAgainst">Protect against:</p>
                <div class="protect-against-inner-outer">
                    <ul class="protect-against-ul">
                        <li class="protect-against-li">
              <span>
                <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="29.852"
                        height="41.815"
                        viewBox="0 0 29.852 41.815"
                >
                  <g
                          id="Group_11984"
                          data-name="Group 11984"
                          transform="translate(0 -0.001)"
                  >
                    <path
                            id="Path_11685"
                            data-name="Path 11685"
                            d="M28.437,8.854l-9.5-8.51a1.346,1.346,0,0,0-2.244,1V4.242A23.757,23.757,0,0,0,6.131,9.13,16.738,16.738,0,0,0,.181,20.251L.007,21.924a1.36,1.36,0,0,0,2.633.583,25.187,25.187,0,0,1,1.415-2.494A11.284,11.284,0,0,1,8.9,15.932a14.085,14.085,0,0,1,7.795-.669v3.107a1.346,1.346,0,0,0,2.244,1l9.5-8.512a1.345,1.345,0,0,0,0-2.008"
                            transform="translate(0 0.001)"
                            fill="#003378"
                    />
                    <path
                            id="Path_11686"
                            data-name="Path 11686"
                            d="M.886,22.888l9.5,8.51a1.347,1.347,0,0,0,2.247-1V27.5a23.768,23.768,0,0,0,10.56-4.888,16.738,16.738,0,0,0,5.95-11.121l.172-1.673a1.359,1.359,0,0,0-2.631-.583,25.2,25.2,0,0,1-1.417,2.494,11.269,11.269,0,0,1-4.842,4.081,14.078,14.078,0,0,1-7.793.669V13.371a1.346,1.346,0,0,0-.8-1.229,1.33,1.33,0,0,0-.55-.117,1.347,1.347,0,0,0-.9.342l-9.5,8.512a1.349,1.349,0,0,0,0,2.008"
                            transform="translate(0.529 10.074)"
                            fill="#003378"
                    />
                  </g>
                </svg>
              </span>
                            <p i18n="storageOverwritten">Storage overwritten too quickly</p>
                        </li>
                        <li class="protect-against-li">
              <span
              ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="35.006"
                      height="34.735"
                      viewBox="0 0 35.006 34.735"
              >
                  <g
                          id="Group_11866"
                          data-name="Group 11866"
                          transform="translate(-104.514 -675.132)"
                  >
                    <path
                            id="Path_11688"
                            data-name="Path 11688"
                            d="M26.818,12.067V2.5A2.517,2.517,0,0,0,24.292,0H5.977a2.512,2.512,0,0,0-2.5,2.5v8.5L.226,14.232A.89.89,0,0,0,0,14.8V18.54a.79.79,0,0,0,.812.789H2.594V21.7L.226,24.044A.89.89,0,0,0,0,24.608v7.6a2.512,2.512,0,0,0,2.5,2.5l21.788.023a2.517,2.517,0,0,0,2.526-2.5v-.361a9.9,9.9,0,1,1,0-19.8"
                            transform="translate(104.514 675.132)"
                            fill="#003378"
                    />
                    <path
                            id="Path_11689"
                            data-name="Path 11689"
                            d="M16.438,6.1a8.2,8.2,0,0,0-5.774,14.007,8.093,8.093,0,0,0,5.774,2.413,8.21,8.21,0,1,0,0-16.42m-.857,5.233a.868.868,0,0,1,1.737,0v3.248a.868.868,0,1,1-1.737,0Zm.857,6.812a.947.947,0,1,1,.947-.947.953.953,0,0,1-.947.947"
                            transform="translate(114.872 682.791)"
                            fill="#f36b5f"
                    />
                    <rect
                            id="Rectangle_4662"
                            data-name="Rectangle 4662"
                            width="35.006"
                            height="34.735"
                            transform="translate(104.514 675.132)"
                            fill="none"
                    />
                  </g>
                </svg>
              </span>
                            <p i18n="@@brokenDamage">Broken or damaged SD cards</p>
                        </li>
                        <li class="protect-against-li">
              <span
              ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="46.444"
                      height="38.22"
                      viewBox="0 0 46.444 38.22"
              >
                  <g
                          id="Group_11985"
                          data-name="Group 11985"
                          transform="translate(0 0)"
                  >
                    <path
                            id="Path_11690"
                            data-name="Path 11690"
                            d="M46.444,16.389c0,3.309-10.4,5.992-23.222,5.992S0,19.7,0,16.389c0-1.82,3.147-3.453,8.112-4.55L10.467,3.15A4.261,4.261,0,0,1,16.64.534l1.333.734a10.864,10.864,0,0,0,10.5,0L29.8.534A4.261,4.261,0,0,1,35.976,3.15l2.357,8.689c4.965,1.1,8.112,2.73,8.112,4.55"
                            transform="translate(0 0)"
                            fill="#003378"
                    />
                    <path
                            id="Path_11691"
                            data-name="Path 11691"
                            d="M57.345,117.131c-1.733.289-3.542.53-5.418.723a104.416,104.416,0,0,1-20.854,0h0c-1.876-.193-3.686-.434-5.418-.723a2.052,2.052,0,0,0-2.4,2.126c0,.011,0,.019,0,.03v0a10.843,10.843,0,0,0,5,8.813,15.332,15.332,0,0,0,5.705,2.092,5.82,5.82,0,0,0,4.851-1.42l.744-.672.13-.118a2.705,2.705,0,0,1,3.624,0l.13.118.744.672a5.82,5.82,0,0,0,4.852,1.42,15.332,15.332,0,0,0,5.705-2.092,10.843,10.843,0,0,0,5-8.813v0c0-.011,0-.019,0-.03a2.052,2.052,0,0,0-2.4-2.126m-19.16,6.719a3.262,3.262,0,0,1-1.733,1.679A4.99,4.99,0,0,1,30,123.418c-.282-.5-.445-.879-.028-1.358a2.376,2.376,0,0,1,1.232-.635,9.1,9.1,0,0,1,5.234.276,4.822,4.822,0,0,1,1.382.725,1.359,1.359,0,0,1,.4.458,1.05,1.05,0,0,1,.064.19,1.429,1.429,0,0,1-.094.776M53,123.418a4.99,4.99,0,0,1-6.456,2.111,3.262,3.262,0,0,1-1.733-1.679,1.429,1.429,0,0,1-.094-.776,1.05,1.05,0,0,1,.064-.19,1.359,1.359,0,0,1,.4-.458,4.822,4.822,0,0,1,1.382-.725,9.1,9.1,0,0,1,5.234-.276,2.376,2.376,0,0,1,1.232.635c.417.479.255.854-.028,1.358"
                            transform="translate(-18.276 -92.053)"
                            fill="#003378"
                    />
                  </g>
                </svg>
              </span>
                            <p i18n="@@physicalTheft">Physical camera theft</p>
                        </li>
                        <li class="protect-against-li">
              <span
              ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40.928"
                      height="35.665"
                      viewBox="0 0 40.928 35.665"
              >
                  <g
                          id="Group_11986"
                          data-name="Group 11986"
                          transform="translate(0 0)"
                  >
                    <path
                            id="Path_11692"
                            data-name="Path 11692"
                            d="M37.53.612a2.094,2.094,0,0,0-2.959,0L28.887,6.3a30.679,30.679,0,0,0-8.429-1.179,31.038,31.038,0,0,0-20,7.286,1.329,1.329,0,0,0-.1,1.905l2.271,2.478a1.344,1.344,0,0,0,1.856.1,25.054,25.054,0,0,1,15.983-5.749,24.444,24.444,0,0,1,3.331.247l-4.246,4.243A20.562,20.562,0,0,0,7.605,20.084a1.345,1.345,0,0,0-.177,1.963l2.278,2.489a1.291,1.291,0,0,0,.584.354L4.176,31.007a2.092,2.092,0,1,0,2.959,2.959L37.53,3.571a2.094,2.094,0,0,0,0-2.959"
                            transform="translate(0 0)"
                            fill="#013378"
                    />
                    <path
                            id="Path_11693"
                            data-name="Path 11693"
                            d="M15.241,7.558l-4.655,4.655a14.641,14.641,0,0,1,4.827,2.468,1.313,1.313,0,0,0,1.766-.174l2.273-2.482a1.348,1.348,0,0,0-.172-1.966,20.66,20.66,0,0,0-4.039-2.5"
                            transform="translate(14.042 10.026)"
                            fill="#013378"
                    />
                    <path
                            id="Path_11694"
                            data-name="Path 11694"
                            d="M21.89,6.766a30.9,30.9,0,0,0-3.5-2.515L14.008,8.636a25.111,25.111,0,0,1,3.864,2.615,1.344,1.344,0,0,0,1.856-.1l2.266-2.478a1.326,1.326,0,0,0-.1-1.9"
                            transform="translate(18.581 5.639)"
                            fill="#013378"
                    />
                    <path
                            id="Path_11695"
                            data-name="Path 11695"
                            d="M11.8,11.218,6.761,16.257l3.746,4.094a1.335,1.335,0,0,0,1.968,0l4.951-5.414a1.328,1.328,0,0,0-.207-1.989A10.117,10.117,0,0,0,11.8,11.218"
                            transform="translate(8.968 14.88)"
                            fill="#013378"
                    />
                  </g>
                </svg>
              </span>
                            <p i18n="@@loassAccess">
                                Lost access to events when device is offline
                            </p>
                        </li>
                    </ul>
                    <div class="protect-table table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>
                                    <span class="visually-hidden">Cloud Plan / Feature</span>
                                </th>
                                <th i18n="@@yourLocalStorage">Your local Storage</th>
                                <th>
                                    <span i18n="@@cloudAddOn">Cloud Add-On</span>
                                    <p i18n="@@enjoyBenefits">
                                        (Enjoy all of the benefits of local storage, plus:)
                                    </p>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let data of planDetails?.rows">
                                <td>{{ data?.name }}</td>

                                <td>
                    <span class="icon-text-wrapper">
                      <span *ngIf="data?.Your_Local_Storage?.value == 'tick'"
                      ><img src="assets/images/checkicon.png" alt="icon"
                      /></span>
                      <span *ngIf="data?.Your_Local_Storage?.value === 'dash'">
                        <span class="empty-span"></span
                        ></span>
                        {{
                            data?.Your_Local_Storage?.title
                                ? data?.Your_Local_Storage?.title
                                : ""
                        }}
                    </span>
                                </td>

                                <td>
                    <span class="icon-text-wrapper">
                      <span *ngIf="data?.Cloud_Add_On?.value == 'tick'"
                      ><img src="assets/images/checkicon.png" alt="icon"
                      /></span>
                      <span *ngIf="data?.Cloud_Add_On?.value == 'dash'">
                        <span class="empty-span"></span
                        ></span>
                        {{
                            data?.Cloud_Add_On?.title
                                ? data?.Cloud_Add_On?.title
                                : ""
                        }}
                    </span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="this.checkoutUrl">
    <div class="mx-auto mt-4 h-75">
        <div class="align-content-center justify-content-center h-75"
             style="display: flex; flex-direction: column;">
            <p class="mb-4 text-center" i18n="@@redirectToShop">
                You will be redirected to the checkout page in a new window.
            </p>
            <p class="text-center">
                <a href="{{ this.checkoutUrl }}" class="btn btn-outline-primary" i18n="@@continueToCheckout">
                    Continue to checkout
                </a>
            </p>
        </div>
    </div>
</ng-container>
